import { useState } from 'react';
import { SchedulerDateNavigationSection } from '@lp/features/Scheduler/components';
import { PhoneSupportInfo } from '@lp/features/Scheduler/SchedulerClinicalSpecialists/components';
import { HubsDataDictionary, SupportViolationItem, WorkdaySyncData } from '@lp/features/Scheduler/types';
import { CSResourcesWithShifts } from '@/api/apis/resources/schedule';
import { CSSchedulerFiltersSection, OrganFiltersRow } from './components';

type CSSchedulerControlHeaderRowProps = {
  readonly?: boolean;
  showPhoneSupport: boolean;
  startDay: Date;
  selectedDate: Date;
  daysInterval: Date[];
  isPlanningMode: boolean;
  showValidation: boolean;
  shiftsData: CSResourcesWithShifts;
  hubsDictionary: HubsDataDictionary;
  workdayData?: WorkdaySyncData;
  supportViolations?: SupportViolationItem[];
  onDateChange: (date: Date) => void;
  isReservationsView: boolean;
  setIsReservationsView: (value: boolean) => void;
};

export const CSSchedulerControlRow = ({
  readonly,
  showPhoneSupport,
  startDay,
  selectedDate,
  daysInterval,
  isPlanningMode,
  showValidation,
  shiftsData,
  hubsDictionary,
  workdayData,
  supportViolations,
  onDateChange,
  isReservationsView,
  setIsReservationsView,
}: CSSchedulerControlHeaderRowProps) => {
  const [showOrganFilters, setShowOrganFilters] = useState(false);

  return (
    <div className="flex flex-col gap-6 w-full">
      <div className="flex items-center gap-2 justify-between w-full">
        <SchedulerDateNavigationSection selectedDate={selectedDate} onDateChange={onDateChange}>
          {!readonly && showPhoneSupport && (
            <PhoneSupportInfo
              selectedDate={selectedDate}
              shiftsData={shiftsData}
              daysInterval={daysInterval}
              startDay={startDay}
              showViolations={isPlanningMode && showValidation}
              violationList={supportViolations}
            />
          )}
        </SchedulerDateNavigationSection>
        <CSSchedulerFiltersSection
          readonly={readonly}
          shiftsData={shiftsData}
          hubsDictionary={hubsDictionary}
          workdayData={workdayData}
          isReservationsView={isReservationsView}
          setIsReservationsView={setIsReservationsView}
          showOrganFilters={showOrganFilters}
          setShowOrganFilters={setShowOrganFilters}
        />
      </div>
      {showOrganFilters && <OrganFiltersRow />}
    </div>
  );
};
